"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Modal;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ModalModule = _interopRequireDefault(require("./Modal.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Modal(_ref) {
  var children = _ref.children,
      _ref$isSimplyClosable = _ref.isSimplyClosable,
      isSimplyClosable = _ref$isSimplyClosable === void 0 ? true : _ref$isSimplyClosable,
      onClose = _ref.closeFunc,
      className = _ref.className,
      style = _ref.style;
  var hideModal = (0, _react.useCallback)(function () {
    if (onClose) onClose();
  }, [onClose]);
  var handleOnClickModal = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
    if (isSimplyClosable) hideModal();
  }, [isSimplyClosable, hideModal]);
  var handleOnClickContent = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
  }, []);
  var keyUpHandler = (0, _react.useCallback)(function (event) {
    if (isSimplyClosable && event.key === "Escape") hideModal();
  }, [isSimplyClosable, hideModal]);
  document.addEventListener("keyup", keyUpHandler, false);
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: handleOnClickModal,
    className: (0, _classnames.default)(_ModalModule.default.modal, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _ModalModule.default.content,
    onClick: handleOnClickContent
  }, children));
}